import { render, staticRenderFns } from "./TwitterPost.vue?vue&type=template&id=5ff1fde3&scoped=true"
import script from "./TwitterPost.vue?vue&type=script&lang=ts"
export * from "./TwitterPost.vue?vue&type=script&lang=ts"
import style0 from "./TwitterPost.vue?vue&type=style&index=0&id=5ff1fde3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff1fde3",
  null
  
)

export default component.exports